require('./_wks-define')('observable');


//////////////////
// WEBPACK FOOTER
// ./~/._core-js@2.4.1@core-js/library/modules/es7.symbol.observable.js
// module id = 97
// module chunks = 0